import { render, staticRenderFns } from "./FormCivilStatus.vue?vue&type=template&id=150b60d8"
import script from "./FormCivilStatus.vue?vue&type=script&lang=js"
export * from "./FormCivilStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports